import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, {useEffect, useRef, useState} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection, EditerBox, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { ChkBox, CustomSelect, TextAreaItem } from "component/basic/formItems";
import { arrParam, bottomChkEl, comFormat, datePramaSet, getDateGap, setDateTime } from "js/function";
import { CarRentDetailItem } from "component/product/car";
import { DotText, FixedPage, FixedSection, PopupContentsTitle } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { CaptionBox, CarDetailControllBasicText, CarDetailControllBox, CarDetailOptionItem, CarDetailOptionTypeBox, CarDetailSection, CarDetailSectionCaptionBox, CarDetailSectionSubTitle, CarDetailSectionTitle, CarDetailSectionTitleArea, CarDetailTextArea, CarDetailTextBox, CarRentDetailOptionBox, CarRentInsuranceItem, CarReviewList, CarSetCaptionList, CarSetInfoItem, CarSetInfoSection, FixedContents } from "component/product/page";

const RentDetail = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;
    const type = param.type;
    const cCode = param.cCode;
    const mCode = param.mCode;

    const location = useLocation();
	const locationData = location?.state ? location?.state : null;
	const filterSettingData = locationData?.filterData;
    const memberCode = locationData?.memberCode;

    const paymentData = locationData?.paymentData;
    const pageEditData = locationData?.pageData;

    const [first,setFirst] =  useState(true);
    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [reviewPopup,setReviewPopup] =  useState(null);
    const [reviewReportPopup,setReviewReportPopup] =  useState(null);

    const [insurancePopup,setInsurancePopup] =  useState(null);
    const [insuranceId,setInsuranceId] =  useState(null);
    const [insuranceName,setInsuranceName] =  useState(null);
    const [paymentDataCar,setPaymentDataCar] = useState(paymentData);

    const [order,setOrder] = useState("desc");

    const [page,setPage] = useState(1);
    const [itemList,setItemList] =  useState([]);
    const itemListBox = useRef(null);
    
    let lastPage = false;
    let settingChk = 0;

    const pageDataApi = useGet({
        url:`/reservation/car/detail?company_mapped_code=${cCode}
        &model_mapped_code=${mCode}
        &review_order=${order}
        &start_date=${type === "edit" ? paymentData?.start_date ? datePramaSet(paymentData?.start_date) : pageEditData?.start_date ? datePramaSet(pageEditData?.start_date) : "" : filterSettingData?.startDtm ? datePramaSet(filterSettingData?.startDtm) : ""}
        &end_date=${type === "edit" ? paymentData?.end_date ? datePramaSet(paymentData?.end_date) : pageEditData?.end_date ? datePramaSet(pageEditData?.end_date) : "" : filterSettingData?.endDtm ? datePramaSet(filterSettingData?.endDtm) : ""}
        &birth=${filterSettingData?.birth||""}
        &career=${filterSettingData?.career||""}
        ${arrParam(filterSettingData?.carCategory,"type[]",false,"id")}
        &search=${filterSettingData?.search||""}
        &insurance_id=${type === "edit" ? (paymentData?.insurance_id ? paymentData?.insurance_id : pageEditData?.insurance_id)||"" : filterSettingData?.insuranceId||""}
        &order=${filterSettingData?.order||""}
        ${arrParam(filterSettingData?.keyword,"keyword[]")}
        ${arrParam(filterSettingData?.size,"size[]")}
        ${arrParam(filterSettingData?.appearance,"appearance[]")}
        ${arrParam(filterSettingData?.maker,"maker[]")}
        ${arrParam(filterSettingData?.fuel,"fuel[]")}
        ${arrParam(filterSettingData?.year,"year[]")}
        ${arrParam(filterSettingData?.option,"option[]")}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data;

    const carData = pageData?.car;
    const review_count = pageData?.review_count;
    const reviews = pageData?.reviews;

    const point_setting = pageData?.point_setting;

    const insuranceApi = useGet({
        url:type === "edit" ? `/company/car/insurance?start_date=${paymentData?.start_date ? datePramaSet(paymentData?.start_date) : pageEditData?.start_date ? datePramaSet(pageEditData?.start_date) : ""}
        &end_date=${paymentData?.end_date ? datePramaSet(paymentData?.end_date) : pageEditData?.end_date ? datePramaSet(pageEditData?.end_date) : ""}
        &company_mapped_code=${cCode}
        &model_mapped_code=${mCode}` : null,
        loginType:null
    });
    const insuranceData = insuranceApi?.data?.car_insurances;

    const reviewDataApi = useGet({
        url:`/review?page=${page}&company_id=${carData?.company_id}&model_id=${carData?.id}&order=${order}`,
        loginType:"login"
    });
    const reviewData = reviewDataApi?.data?.reviews;

    const [reviewContents,setReviewContents] =  useState({
        reason:"",
        text:"",
        is_block:0
    });
    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    function reviewDataCh(key,val){
        let oldData = {...reviewContents};
        oldData[key] = val;
        setReviewContents(oldData);
    }

    function reviewDataReSet(){
        let reSetData = {
            reason:"",
            text:"",
            is_block:0
        };
        setReviewContents(reSetData);
        setBtnChk(true);
    }

    function closeFuc(){
        navigate("/rent/reservation",{state: {filterData:filterSettingData,cCode:cCode,mCode:mCode}})
    }

    function reviewReport(reviewId){
        if(submitChk){
            setSubmitChk(false);
            window.loadingBox(true);

            let formData = new FormData();
            formData.append("review_id", reviewId);
            formData.append("reason", reviewContents?.reason);
            formData.append("reason_detail", reviewContents?.text);
            formData.append("is_block", reviewContents?.is_block);

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/review/report/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    window.loadingBox(false);
                    setBtnChk(true);

                    window.errPopupOpen({
                        alert:`리뷰 신고${reviewContents?.is_block === 1 ? "/차단" : ""} 완료`,
                        data:`해당 리뷰를 신고${reviewContents?.is_block === 1 ? "/차단" : ""}하였습니다.<br/>관리자가 검토 후, 운영정책에 의거해 조치됩니다.`,
                        closeType:false,
                        func:()=>{
                            setReviewReportPopup(null);
                            reviewDataReSet();
                            window.location.reload(true);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    window.loadingBox(false);
                }
            })
        }
    }

    function itemListReSet(){
        setPage(1);
        if(itemListBox.current){
            itemListBox.current.scrollTop = 0;
        }
    }

    useEffect(() => {
        itemListReSet();
    }, [order]);

    function addPage(){
        setLoadingBoxOpen(true);
        setPage(page + 1);
        settingChk = 1;
        setTimeout(() => {
            settingChk = 0;
        }, 300);
    };

    useEffect(() => {
        if(reviewData?.data && reviewData?.data.length > 0){
            if(page == 1){
                setItemList([...reviewData?.data]);
            }else{    
                setItemList(prev => [...prev, ...reviewData?.data]);
            }
        }else{
            setItemList([]);
        }

        lastPage = reviewData?.current_page < reviewData?.last_page;

        setLoadingBoxOpen(false);
    }, [reviewDataApi]);

    function handleScroll(item){
        if(bottomChkEl(item) && lastPage && settingChk == 0){
            addPage();
        }
    };

    useEffect(() => {
        if(pageDataApi?.success === false){
            window.errPopupOpen({
                alert:"차량 조회 실패",
                data:"예약 가능 차량이 존재하지 않습니다.",
                closeType:false,
                func:()=>{
                    navigate(-1)
                }
            });
        }
        if(pageData){
            setLoadingBoxOpen(false);
        }
    }, [pageDataApi]);

    useEffect(() => {
        setTimeout(() => {
            setLoadingBoxOpen(false);
        }, 2000);
    }, []);

    useEffect(() => {
        if(reviewContents?.reason && reviewContents?.reason !== ""){
            setBtnChk(false);
        }else{
            setBtnChk(true);
        }
    }, [reviewContents]);

    useEffect(() => {
        if(insuranceData && type === "edit"){
            if(paymentData?.insurance_id || pageEditData?.insurance_id){
                setInsuranceId(paymentData?.insurance_id ? paymentData?.insurance_id : pageEditData?.insurance_id);
                setInsuranceName(paymentData?.insurance_name ? paymentData?.insurance_name : pageEditData?.insurance_name);
            }else{
                setInsuranceId(insuranceData[0]?.id);
                setInsuranceName(insuranceData[0]?.name);
            }
        }
    }, [insuranceApi]);

    useEffect(() => {
        if (first && carData) {
            setFirst(false);

            if (!window.wcs) return;

            if (!window.wcs_add) window.wcs_add = {};
            window.wcs_add["wa"] = process.env.REACT_APP_NAVER_ANALYTIC_ID;

            var _conv = {};
            _conv.type = 'view_product';
            _conv.items = [{
                id: id,
                name: carData?.name,
                category: "",
                quantity: "1",
                payAmount: carData?.information,
                option: ""
            }];
            window.wcs.trans(_conv);
        }
    }, [carData]);

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                mBtn={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"차량 상세"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={type === "edit" ? 1 : 0}
                    closeFunc={()=>{}}
                />
                <PageTitle
                    pageBack={()=>{navigate(-1)}}
                    contents="차량 정보"
                />
                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarRentDetailItem
                            maker={carData?.maker}
                            modelName={carData?.name}
                            carCategory={carData?.type}
                            companyName={carData?.company_name}
                            isOutsourcing={carData?.is_outsourcing}
                            eventRate={carData?.specialEventRate}
                            car_image={carData?.image_url}
                            passengerNum={carData?.passenger_number}
                            fuelType={carData?.fuel}
                            min_year={carData?.min_year}
                            max_year={carData?.max_year}
                        />
                        <div className={`carDetailDescription`}>
                            {carData?.is_outsourcing === 1
                            ?
                                "AMANO 렌터카허브는 입점사뿐만 아니라 비입점 제휴 렌터카사 상품 정보도 함께 제공합니다. 제휴 렌터카사 예약 시에는 제휴사 영업장(차고지) 에서 차량을 인도받으실 수 있습니다."
                            :
                                "AMANO 렌터카허브는 제휴사(입점, 비입점)가 제공하는 상품 정보를 비교·중개하는 플랫폼입니다. 아마노코리아㈜는 통신판매 당사자가 아닌 통신판매중개자로서, 상품 정보·거래·이용 및 환불 등에 대한 책임은 각 판매자에게 있습니다."
                            }
                        </div>
                        <CarDetailSection
                            captions={[
                                "안내된 대여 조건과 일치하지 않을 경우 현장에서 예약이 취소될 수 있습니다.",
                                "대여 조건에 따라 예약 취소가 발생될 경우 환불 규정과 동일하게 적용됩니다."
                            ]}
                            title="대여조건 안내"
                        >
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailOptionTypeBox
                                    data={[
                                        {
                                            addClass: carData?.is_pet == 0 ? "rColor" : "",
                                            icon: "rant_condition_0",
                                            name: "반려동물 동반",
                                            text: carData?.is_pet == 0 ? "불가" : carData?.is_pet == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass: carData?.is_foreigner == 0 ? "rColor" : "",
                                            icon: "rant_condition_1",
                                            name: "외국인 대여",
                                            text: carData?.is_foreigner == 0 ? "불가" : carData?.is_foreigner == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass: carData?.is_fishing == 0 ? "rColor" : "",
                                            icon: "rant_condition_2",
                                            name: "낚시용품 지참",
                                            text: carData?.is_fishing == 0 ? "불가" : carData?.is_fishing == 1 ? "가능" : "-"
                                        },
                                        {
                                            addClass: carData?.is_smoke == 0 ? "rColor" : "",
                                            icon: "rant_condition_3",
                                            name: "금연 차량",
                                            text: carData?.is_smoke == 0 ? "금연" : carData?.is_smoke == 1 ? "흡연 가능" : "-"
                                        }
                                    ]}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`운전자 연령`}
                                    text={`<span class='wbTextColor'>만 ${carData?.min_age || "-"}세</span> 이상`}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`면허 유형`}
                                    text={`<span class='wbTextColor'>${carData?.license || "-"}</span> 이상`}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`운전 경력`}
                                    text={`<span class='wbTextColor'>${carData?.career || "-"}년</span> 이상`}
                                />
                            </CarDetailTextArea>
                            <CarDetailSectionCaptionBox>
                                <CarDetailSectionSubTitle title="예약 전 안내사항"/>
                                <EditerBox addClass="" data={carData?.information}/>
                            </CarDetailSectionCaptionBox>
                        </CarDetailSection>
                        <CarDetailSection
                            captions={[
                                "예약된 차량 옵션은 현장에서 대여 시 일부 상이할 수 있습니다."
                            ]}
                            title="차량 옵션 정보"
                        >
                            {carData?.options && carData?.options?.length > 0 ?
                                <>
                                    <CarDetailSectionSubTitle title="포함된 옵션"/>
                                    <CarRentDetailOptionBox>
                                        {carData?.options && carData?.options?.map((item, i) => (
                                            <CarDetailOptionItem
                                                key={i}
                                                active={true}
                                                text={item}
                                            />
                                        ))}
                                    </CarRentDetailOptionBox>
                                </>
                                : ""}
                            {carData?.non_options && carData?.non_options?.length > 0 ?
                                <>
                                    <CarDetailSectionSubTitle addClass="gTextColor" title="포함되지 않은 옵션"/>
                                    <CarRentDetailOptionBox>
                                        {carData?.non_options && carData?.non_options?.map((item, i) => (
                                            <CarDetailOptionItem
                                                key={i}
                                                active={false}
                                                text={item?.name}
                                            />
                                        ))}
                                    </CarRentDetailOptionBox>
                                </>
                                : ""}
                        </CarDetailSection>
                        <CarDetailSection
                            title={`차량 리뷰 <span class='wbTextColor'>${comFormat(review_count ? review_count : 0)}</span>`}
                            titleSubItem={
                                <CustomSelect
                                    boxAddClass=""
                                    addClass="absoluteSel"
                                    inputName={null}
                                    placeholder="정렬 선택"
                                    value={order}
                                    func={(name, val) => {
                                        setOrder(val)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id: "grade_desc", name: "평점 높은 순"},
                                        {id: "grade_asc", name: "평점 낮은 순"},
                                        {id: "desc", name: "최신 순"}
                                    ]}
                                />
                            }
                        >
                            {reviews && reviews?.length > 0 ?
                                <>
                                    {reviews && reviews?.map((item, i) => (
                                        <CarReviewList
                                            key={i}
                                            id={item.id}
                                            user_id={item.user_id}
                                            grade={item.grade}
                                            name={item.name}
                                            created_at={item.created_at}
                                            contents={item.contents}
                                            reportFunc={(data) => {
                                                if (localStorage.getItem("token")) {
                                                    setReviewReportPopup({
                                                        addClass: "",
                                                        title: "리뷰 신고/차단",
                                                        subTitle: null,
                                                        closeType: true,
                                                        closeFunc: (e) => {
                                                            reviewDataReSet();
                                                            setReviewReportPopup(null)
                                                        },
                                                        reviewData: item
                                                    });
                                                } else {
                                                    window.welComeOpen();
                                                }
                                            }}
                                        />
                                    ))}
                                    <BtnItem
                                        addClass="subColor"
                                        contents="리뷰 더보기"
                                        func={() => {
                                            setReviewPopup({
                                                addClass: "nonePcTitleBox reviewListPopup",
                                                title: "차량 리뷰",
                                                subTitle: null,
                                                closeType: true,
                                                closeFunc: (e) => {
                                                    setReviewPopup(null);
                                                    itemListReSet();
                                                },
                                            });
                                        }}
                                    />
                                </>
                                :
                                <NotItems addClass="min" text={`작성된 리뷰가 없습니다.`}/>
                            }
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        {type === "edit" ? 
                        <CarDetailControllBox
                            addClass={"nonFixed"}
                            title={"변경할 차량을 선택해주세요."}
                            subTitle={null}
                        >
                            <CarDetailControllBasicText
                                addClass="subText"
                                text={"대여/반납일정 내 변경 가능한 차량만을 조회합니다."}
                            />
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="bSize"
                                    name="기존 대여 요금"
                                    text={`<span class='wbTextColor'>${comFormat(paymentData?.car?.discount_price || paymentData?.car?.original_price ? (paymentData?.car?.discount_price ? paymentData?.car?.discount_price : paymentData?.car?.original_price)||"0" : pageEditData?.original_price||"0")} 원</span>`}
                                />
                                <CarSetInfoItem
                                   addClass="bSize"
                                   name="변경 대여 요금"
                                   text={`<span class='wbTextColor'>${comFormat(carData?.discount_price ? carData?.discount_price : carData?.original_price)} 원</span>`}
                                />                               
                            </CarSetInfoSection>
                            <BtnBox
                                boxType=""
                                addClass={"mFixed col2"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass=""
                                    contents={`선택 완료`}
                                    func={() => {
                                        setInsurancePopup({
                                            addClass:"subTitle_line_2",
                                            title:"자차보험 선택",
                                            subTitle:"선택한 보험에 따라 보험 가격이<br/>최종 결제금액에 반영됩니다.",
                                            closeType:true,
                                            closeFunc:(e) => {
                                                setInsurancePopup(null);
                                            }
                                        });
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                        :
                        <CarDetailControllBox
                            addClass={"nonFixed titleColor"}
                            title={"예약 정보"}
                            subTitle={filterSettingData?.startDtm && filterSettingData?.endDtm ? `총 ${getDateGap(filterSettingData?.startDtm,filterSettingData?.endDtm,"time",null)} 시간` : null}
                        >
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="차량 대여요금 (자차보험 포함)"
                                    text={`${comFormat((carData?.discount_price ? carData?.discount_price : carData?.original_price)||"0")} 원`}
                                /> 
                                <CarSetInfoItem
                                    addClass=""
                                    name="예약 시간"
                                    text={filterSettingData?.startDtm && filterSettingData?.endDtm ? `${getDateGap(filterSettingData?.startDtm,filterSettingData?.endDtm,"time",null)} 시간` : null}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name="보험 정보"
                                    text={filterSettingData?.insuranceName||"-"}
                                />
                                <CarSetInfoItem
                                    addClass="mSize"
                                    name="대여/반납일시"
                                    text={null}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name={filterSettingData?.startDtm ? setDateTime(filterSettingData?.startDtm,"dayyyMinmmddhh",null) : "-"}
                                    text={`부터`}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name={filterSettingData?.endDtm ? setDateTime(filterSettingData?.endDtm,"dayyyMinmmddhh",null) : "-"}
                                    text={`까지`}
                                />
                            </CarSetInfoSection>
                            <CarSetCaptionList
                                addClass={point_setting?.join_reward_type === "coupon" || point_setting?.join_reward_type === "point" ? "" : "notCaptions"}
                                captions={
                                    point_setting?.join_reward_type === "coupon" ? 
                                    [{
                                        type:"쿠폰",
                                        text:`${point_setting?.join_coupon_name||"-"} (-${comFormat(point_setting?.discount_value||"0")}${point_setting?.discount_type == "percent" ? `%` : `원`})`
                                    },
                                    /*{
                                        type:"포인트",
                                        text:`예약금액 기준 ${point_setting?.reservation_point||"0"}% 포인트 적립 (${comFormat(Math.floor(Number((carData?.discount_price ? carData?.discount_price : carData?.original_price)||0) * (Number(point_setting?.reservation_point||0) / 100)))} 포인트)`
                                    }*/]
                                    : point_setting?.join_reward_type === "point" ? 
                                    [/*{
                                        type:"포인트",
                                        text:`회원가입 시 포인트 지급 (${comFormat(Math.floor(point_setting?.join_point)||"0")} 포인트)`
                                    },
                                    {
                                        type:"포인트",
                                        text:`예약금액 기준 ${point_setting?.reservation_point||"0"}% 포인트 적립 (${comFormat(Math.floor(Number((carData?.discount_price ? carData?.discount_price : carData?.original_price)||0) * (Number(point_setting?.reservation_point||0) / 100)))} 포인트)`
                                    }*/]
                                    :
                                    []
                                }
                            />
                            <BtnBox
                                boxType=""
                                addClass={"row2_re mCol2 mFixed"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass=""
                                    contents={`${comFormat((carData?.discount_price ? carData?.discount_price : carData?.original_price)||"0")} 원 예약하기<img src="/assets/images/basic/filter_btn_move.svg"/>`}
                                    func={() => {
                                        if(localStorage.getItem("token")){
                                            navigate("/rent/reservation",{state: {filterData:filterSettingData,cCode:cCode,mCode:mCode}})
                                        }else{
                                            window.nonLoginOpen(null, filterSettingData, closeFuc)
                                        }
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                        }
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={reviewPopup} basicPB={false} mSize={true} conterntsScroll={(item)=>handleScroll(item)}>
                <CarDetailSectionTitleArea>
                    <CarDetailSectionTitle title={`차량 리뷰 <span class='wbTextColor'>${comFormat(review_count ? review_count : 0)}</span>`}/>
                    <CustomSelect
                        boxAddClass=""
                        addClass="absoluteSel"
                        inputName={null}
                        placeholder="정렬 선택"
                        value={order}
                        func={(name,val) => {
                            setOrder(val)
                        }}
                        disabled={false}
                        valKey="id"
                        nameKey="name"
                        options={[
                            {id:"grade_desc",name:"평점 높은 순"},
                            {id:"grade_asc",name:"평점 낮은 순"},
                            {id:"desc",name:"최신 순"}
                        ]}
                    />
                </CarDetailSectionTitleArea>
                <div className="reviewPopup_listSection">
                    {itemList && itemList?.length > 0 ? 
                        <>
                            {itemList && itemList?.map((item, i) => (
                                <CarReviewList
                                    key={i}
                                    id={item.id}
                                    user_id={item.user_id}
                                    grade={item.grade}
                                    name={item.name}
                                    created_at={item.created_at}
                                    contents={item.contents}
                                    reportFunc={(data)=>{
                                        if(localStorage.getItem("token")){
                                            setReviewReportPopup({
                                                addClass:"",
                                                title:"리뷰 신고/차단",
                                                subTitle:null,
                                                closeType:true,
                                                closeFunc:(e) => {
                                                    reviewDataReSet();
                                                    setReviewReportPopup(null)
                                                },
                                                reviewData:item
                                            });
                                        }else{
                                            window.welComeOpen();
                                        }
                                    }}
                                />
                            ))}
                        </>
                    :
                        <NotItems addClass="min" text={`작성된 리뷰가 없습니다.`}/>
                    }
                </div>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"닫기"}
                        func={() => {
                            setReviewPopup(null);
                            itemListReSet();
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={reviewReportPopup} basicPB={false} mSize={true}>
                <PopupContentsTitle title="신고 대상 리뷰"/>
                <CarReviewList
                    addClass="bgReviewList"
                    id={reviewReportPopup?.reviewData?.id}
                    user_id={reviewReportPopup?.reviewData?.user_id}
                    grade={reviewReportPopup?.reviewData?.grade}
                    name={reviewReportPopup?.reviewData?.name}
                    created_at={reviewReportPopup?.reviewData?.created_at}
                    contents={reviewReportPopup?.reviewData?.contents}
                    reportFunc={null}
                />
                <CustomSelect
                    addClass="absoluteSel"
                    inputName="신고 사유 선택"
                    placeholder="사유를 선택해주세요"
                    value={reviewContents?.reason}
                    func={(name,val) => {
                        reviewDataCh("reason",val);
                    }}
                    disabled={false}
                    valKey="value"
                    nameKey="value"
                    options={[
                        {value:"리뷰와 관련없는 내용"},
                        {value:"부적절한 표현"},
                        {value:"허위사실"},
                        {value:"상업적 홍보"},
                        {value:"개인정보 누출 위험"},
                        {value:"기타"}
                    ]}
                />
                <TextAreaItem
                    addClass=""
                    inputName="사유 상세 입력 (선택)"
                    placeholder="신고하시는 사유를 최대한 자세히 입력해주세요."
                    max={null}
                    maxChk={false}
                    value={reviewContents?.text}
                    func={(value)=>reviewDataCh("text",value)}
                />
                <PopupContentsTitle title="신고 대상 차단"/>
                <ChkBox
                    addClass=""
                    func={(e) => {reviewDataCh("is_block",e.target.checked ? 1 : 0)}}
                    checkedType={reviewContents?.is_block == 1 ? true : false}
                    label={`<b class='wbTextColor'>해당 회원과 회원이 등록한 게시물을 차단합니다.</b>`}
                    chkFunc={null}
                />
                <CaptionBox addClass="reviewCaptionBox">
                    <DotText text={"신고 사유에 포함되지 않는 내용은 기타를 선택하여 사유 상세 입력란을 활용해 작성해주시기 바랍니다."}/>
                    <DotText text={"신고해주신 내용은 관리자가 검토 후, 운영정책에 의거해 조치가 진행됩니다."}/>
                </CaptionBox>
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"취소"}
                        func={() => {
                            setReviewReportPopup(null);
                            reviewDataReSet();
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"신고하기"}
                        disabled={btnChk}
                        func={() => {reviewReport(reviewReportPopup?.reviewData?.id)}}
                    />
                </BtnBox>
            </CustomPopup>

            <CustomPopup data={insurancePopup} basicPB={false} mSize={false}>
                <div className="insurancePopup_list">
                    {insuranceData && insuranceData?.length > 0 ? 
                    <>
                        {insuranceData && insuranceData?.map((item,i)=>(
                            <CarRentInsuranceItem
                                key={i}
                                type="edit"
                                value={insuranceId}
                                id={item.id}
                                name={item.name}
                                func={(id)=>{
                                    setInsuranceId(id);
                                    setInsuranceName(item.name);
                                }}

                                driving_age={item.min_age}
                                driving_experience={item.min_career}
                                price={item.insurance_price}
                                limit_compensation={item.insurance_limit}
                                indemnity={item.charge_immunity}

                                furlough_compensation_fee={item.rest_price}
                                single_accident={item.include_single_accident === 1 ? "보장" : "미보장"}
                                tire_damage_guarantees={item.include_tire_damage === 1 ? "보장" : "미보장"}
                            />
                        ))}
                    </>
                    :
                    <NotItems addClass="bigText sectionNotItem" text="이용 가능한 보험이 없습니다."/>}
                </div>
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"취소"}
                        func={() => {
                            setInsurancePopup(null);
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"차량/보험 선택 완료"}
                        disabled={false}
                        func={() => {
                            setInsurancePopup(null);
                            let oldData = {...paymentDataCar};
                            oldData.reservationData = pageData;
                            oldData.insurance_id = insuranceId;
                            oldData.insurance_name = insuranceName;
                            oldData.cCode = cCode;
                            oldData.mCode = mCode;
                            setPaymentDataCar(oldData);
                            navigate(`/reservation/edit/${id}`,{state:{paymentData:oldData,pageData:pageEditData,memberCode:memberCode}})
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <Footer pcOnly={true}/>            
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default RentDetail;